<template>
    <div>
        <loading-component :value="loading"></loading-component>
        <v-container>
            <v-layout row>
                <v-flex xs6>
                    <v-select
                            label="Select Ticket Type"
                            :items="ticket_types"
                            v-model="selected_type"
                            item-text="title"
                            item-value="id"
                    ></v-select>
                </v-flex>
            </v-layout>
            <v-layout row>
                <v-card style="width: 100%">
                    <v-btn v-if="last_selected_subtree && (canAddQuestion)" @click="dialog = true" style="float: right"
                           icon color="primary">
                        <v-icon>fa-plus</v-icon>
                    </v-btn>
                    <v-btn v-if="canDeleteQuestion" @click="deleteQuestion" style="float: right"
                           icon color="primary">
                        <v-icon>fa-trash</v-icon>
                    </v-btn>
                    <v-btn v-if="canDeleteQuestion" @click="openQuestionModal" style="float: right"
                           icon color="primary">
                        <v-icon>fa-edit</v-icon>
                    </v-btn>
                    <v-btn v-if="last_selected_subtree && (canAddField)" @click="formDialog = true" style="float: right"
                           icon color="primary">
                        <v-icon>assignment</v-icon>
                    </v-btn>
                    <v-card-title>
                        <b>Ticket Type Tree</b>
                    </v-card-title>
                    <v-card-text>
                        <v-treeview
                                activatable
                                :active.sync="active"
                                return-object
                                item-key="key"
                                active-class="red_back"
                                loading-icon="sync" v-if="selected_type && tree.length" :items="tree"
                                :load-children="loadChildren"></v-treeview>
                        <p v-else-if="selected_type">No questions</p>
                        <p v-else>No selected ticket type</p>
                    </v-card-text>
                </v-card>
            </v-layout>
        </v-container>
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title>Add new question</v-card-title>
                <v-card-text>
                    <v-text-field v-model="question.title" label="Question Title"></v-text-field>
                    <v-text-field v-model="question.details" label="Question Details"></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="dialog = false">Close</v-btn>
                    <v-btn flat color="primary" :disabled="disable_submit" @click="submit">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="formDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="formDialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Settings</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn dark flat @click="formDialog = false">Save</v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <ticket-question-form v-if="canAddField" :fields_array="form_fields"
                                      :question_id="last_selected_subtree.id"></ticket-question-form>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import LoadingComponent from "@/components/LoadingComponent";
    import TicketQuestionForm from "@/views/customer_care/ticketing/TicketQuestionForm";

    export default {
        name: 'TicketsManagement',
        title: 'Tickets Management',
        components: {TicketQuestionForm, LoadingComponent},
        data: () => ({
            active: [],
            ticket_types: [],
            loading: false,
            dialog: false,
            selected_type: null,
            tree: [],
            question: {},
            last_selected_subtree: null,
            formDialog: false,
            form_url: null,
            form_fields: [],
            disable_submit: false
        }),
        mounted() {
            this.axios.get('ticket_type?perPage=100')
                .then(res => this.ticket_types = res.data.data.data)
                .catch(err => console.log(err.message));
        },
        computed: {
            canAddQuestion() {
                return Array.isArray(this.last_selected_subtree) || !this.last_selected_subtree.is_leaf ||
                    !this.last_selected_subtree.children.length;
            },
            canAddField() {
                return this.last_selected_subtree && !Array.isArray(this.last_selected_subtree) && this.last_selected_subtree.is_leaf
            },
            canDeleteQuestion() {
                return this.last_selected_subtree && !Array.isArray(this.last_selected_subtree);
            },
        },
        watch: {
            selected_type(val) {
                this.loadFirstLevel();
            },
            formDialog(val) {
                if (val) this.form_fields = this.last_selected_subtree.children;
            },
            active: {
                handler(val, old) {
                    if (val.length > 0) {
                        if (!Array.isArray(val[0].children)) {
                            this.active = [old[0]];
                            return;
                        }
                        this.last_selected_subtree = val[0];
                    } else {
                        this.last_selected_subtree = this.tree;
                    }
                },
                deep: true
            }
        },
        methods: {
            openQuestionModal() {
                if (!this.last_selected_subtree || Array.isArray(this.last_selected_subtree)) {
                    return;
                }
                this.question = this.last_selected_subtree;
                this.dialog = true;
            },
            loadFirstLevel() {
                this.axios.get(`ticket_type/${this.selected_type}/questions`)
                    .then(res => {
                        res.data.data.list.forEach(e => {
                            e.name = e.title;
                            e.children = [];
                            e.key = e.id + 'QUESTION';
                        });
                        this.tree = res.data.data.list;
                        this.last_selected_subtree = this.tree;
                    })
                    .catch(err => console.log(err.message));
            },
            async loadChildren(elem) {
                this.last_selected_subtree = elem;
                await this.axios.get(`ticket_type/${this.selected_type}/questions?parent_id=${elem.id}`)
                    .then(res => {
                        if (res.data.data.type === 'FORM') {
                            this.form_fields = res.data.data.list;
                        }
                        res.data.data.list.forEach(e => {
                            e.name = e.title;
                            if (res.data.data.type !== 'FORM') {
                                e.children = [];
                                e.key = e.id + 'QUESTION';
                            } else {
                                e.key = e.id + 'FORM';
                            }
                        });
                        elem.children = res.data.data.list;
                        this.active = [elem];
                    });
            },
            async submit() {
                if (!this.question.title || !this.selected_type) {
                    window.getApp.$emit("SHOW_TOAST", "uncompleted info", "red");
                    return;
                }
                this.disable_submit = true;

                if (!this.question.details) {
                    this.question.details = null;
                }
                if (this.question.id) {

                    this.axios.put(`ticket_question/${this.last_selected_subtree.id}`, this.question)
                        .then(() => {
                            this.question = {};
                            this.loadFirstLevel();
                        })
                        .catch(err => console.log(err.message))
                        .finally(() => {
                            this.dialog = false;
                            this.disable_submit = true;
                        });

                } else {
                    let data = {...this.question};
                    data.question_id = this.last_selected_subtree.id;
                    data.type_id = this.selected_type;
                    await this.axios.post(`ticket_type/${this.selected_type}/questions`, data)
                        .then(res => {
                            res.data.data.name = res.data.data.title;
                            res.data.data.children = [];
                            if (Array.isArray(this.last_selected_subtree)) {
                                this.last_selected_subtree.push(res.data.data);
                            } else {
                                this.last_selected_subtree.is_leaf = false;
                                this.last_selected_subtree.children.push(res.data.data);
                            }
                            this.question = {};
                            this.dialog = false;
                        })
                        .catch(err => {
                            try {
                                if (err.response.data.message) {
                                    window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red", ['center', 'top']);
                                } else {
                                    window.getApp.$emit("SHOW_TOAST", err.message, "red", ['center', 'top']);
                                }
                            } catch (e) {
                                console.log(err.message, e.message);
                            }
                        })
                        .finally(() => {
                            this.disable_submit = true;
                        });
                }

            },
            deleteField(item) {
                let c = confirm("are you sure you want to delete!");
                if (c !== true) {
                    return
                }
                this.loading = true;
                this.axios.delete(`ticket_question_field/${item.id}`)
                    .then(() => {
                        let idx = this.form_fields.findIndex((e) => e.id === item.id);
                        if (idx >= 0) {
                            this.form_fields.splice(idx, 1);
                        }
                    }).catch(err => console.log(err.message)).finally(() => this.loading = false);
            },
            deleteQuestion() {
                let c = confirm("are you sure you want to delete!");
                if (c !== true) {
                    return
                }
                this.loading = true;
                this.axios.delete(`ticket_question/${this.last_selected_subtree.id}`)
                    .then(() => this.loadFirstLevel())
                    .catch(err => console.log(err.message))
                    .finally(() => this.loading = false);
            }
        }
    }
</script>

<style>
    .red_back {
        background-color: lightgray !important;
    }
</style>
